var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.25C3.10051 11.25 0.75 8.8995 0.75 6C0.75 3.10051 3.10051 0.75 6 0.75C8.8995 0.75 11.25 3.10051 11.25 6C11.25 8.8995 8.8995 11.25 6 11.25ZM6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z",
    fill: "#2FB672"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70341 3.79156C4.82831 3.72729 4.97866 3.7382 5.09296 3.81985L7.71796 5.69485C7.81651 5.76524 7.875 5.87889 7.875 6C7.875 6.12111 7.81651 6.23476 7.71796 6.30515L5.09296 8.18015C4.97866 8.2618 4.82831 8.27272 4.70341 8.20844C4.57851 8.14416 4.5 8.01547 4.5 7.875V4.125C4.5 3.98453 4.57851 3.85584 4.70341 3.79156Z",
    fill: "#2FB672"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoicon);
export default __webpack_public_path__ + "static/media/videoicon.1d840191e99acde488848e9a9c561fb8.svg";
export { ForwardRef as ReactComponent };